import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import classList from 'flarum/common/utils/classList';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import TagsPage from 'flarum/tags/components/TagsPage';
import sortTags from 'flarum/tags/common/utils/sortTags';
import humanTime from 'flarum/common/helpers/humanTime';
import extractText from 'flarum/common/utils/extractText';
import IndexPage from 'flarum/forum/components/IndexPage';
import textContrastClass from 'flarum/common/helpers/textContrastClass';
import Link from 'flarum/common/components/Link';
import CustomFilterNav from './components/CustomFilterNav';

export default function () {
  override(TagsPage.prototype, 'hero', function () {
    const bgBannerImgUrl = app.forum.attribute('baseUrl') + '/assets/images/banner_linear_400.png';
    const title = extractText(app.translator.trans(app.forum.attribute('welcomeTitle')));
    const desc = extractText(app.translator.trans(app.forum.attribute('welcomeMessage')));

    return (
      <div className="dvdfab-banner" style={{ background: `url(${bgBannerImgUrl}) no-repeat center top` }}>
        <div className="container">
          <h1 className="Hero-title">{title}</h1>
          <div className="Hero-subtitle">{desc}</div>
        </div>
      </div>
    );
  });

  override(TagsPage.prototype, 'sidebar', function () {
    return (
      <>
        <div>
          <CustomFilterNav />
          {/* <CategoriesSelectExample /> */}
        </div>
        <nav className="TagsPage-nav IndexPage-nav sideNav">
          <ul>{listItems(this.sidebarItems().toArray())}</ul>
        </nav>
      </>
    );
  });

  override(IndexPage.prototype, 'navItems', (original) => {
    // 删除 tags
    // if (items.has('quest_page')) {
    //   items.remove('quest_page');
    // }

    // if (items.has('badges')) {
    //   items.remove('badges');
    // }
    // if (items.has('tags')) {
    //   // 重新设置更高的优先级，比如 999
    //   items.setPriority('tags', 999);
    // }
    const items = original();
    let newItems = new ItemList();

    const keep = ['tags', 'allDiscussions', 'following', 'privateDiscussions']; // 白名单

    keep.forEach((key) => {
      if (items.has(key)) {
        newItems.add(key, items.get(key), items.getPriority(key));
      }
    });

    if (newItems.has('tags')) {
      // 重新设置更高的优先级，比如 999
      newItems.setPriority('tags', 999);
    }
    if (newItems.has('allDiscussions')) {
      // 重新设置更高的优先级，比如 999
      newItems.setPriority('allDiscussions', 800);
    }
    if (newItems.has('following')) {
      // 重新设置更高的优先级，比如 999
      newItems.setPriority('following', 700);
    }
    if (newItems.has('privateDiscussions')) {
      // 重新设置更高的优先级，比如 999
      newItems.setPriority('privateDiscussions', 600);
    }

    return newItems;
  });

  override(TagsPage.prototype, 'tagTileView', function (original, tag) {
    // const lastPostedDiscussion = tag.lastPostedDiscussion();
    // 最多显示7个子分类
    const children = sortTags(tag.children() || []).slice(0, 7);

    return (
      <li className={classList('TagTile', { colored: tag.color() }, textContrastClass(tag.color()))} style={{ '--tag-bg': tag.color() }}>
        <Link className="TagTile-info" href={app.route.tag(tag)}>
          {/* {tag.icon() && tagIcon(tag, {}, { useColor: false })} */}

          <h3 className="TagTile-name">
            <i className="custom-icon" style={{ backgroundColor: tag.color() }}></i>
            <span>{tag.name()}</span>
          </h3>
          <p className="TagTile-description">{tag.description()}</p>
          {!!children.length && (
            <div className="TagTile-children">
              {children.map((child) => [
                <Link href={app.route.tag(child)}>
                  <span style={{ backgroundColor: child.color() }} className="child-icon"></span>
                  <span>{child.name()}</span>
                </Link>,
                ' ',
              ])}
            </div>
          )}
        </Link>
        {/* {lastPostedDiscussion ? (
          <Link className="TagTile-lastPostedDiscussion" href={app.route.discussion(lastPostedDiscussion, lastPostedDiscussion.lastPostNumber())}>
            <span className="TagTile-lastPostedDiscussion-title">{lastPostedDiscussion.title()}</span>
            {humanTime(lastPostedDiscussion.lastPostedAt())}
          </Link>
        ) : (
          <span className="TagTile-lastPostedDiscussion" />
        )} */}
      </li>
    );
  });
}
